import React from "react";
import TransferPageTemplate from "../../../components/TransferPageTemplate";
import transfersData from "../../../data/transfers.json";

const BudapestToDebrecenTransferPage = () => {
  // Find the Budapest to Debrecen transfer data from the transfers.json file
  const transferData = transfersData.find(transfer => transfer.id === "budapest-to-debrecen");

  return (
    <TransferPageTemplate transferData={transferData} />
  );
};

export default BudapestToDebrecenTransferPage;
